import { StartListeningOptions } from './listenerMiddlewareTypes';
import { CardResponse, View } from '@yleisradio/areena-types';
import { loadCardPage } from '../view/thunks';
import { isAnyOf } from '@reduxjs/toolkit';
import { isHighlightCard, isList } from '../../client/typeGuards';
import { addHighlightCard } from '../view/actions';

const emptyListLoadedListener: StartListeningOptions = {
  predicate: (action, currentState) => {
    if (action.type === loadCardPage.fulfilled.type) {
      const payload: CardResponse | undefined = action.payload;

      if (payload) {
        const {
          meta: payloadMeta,
          data: payloadData,
          notifications: payloadNotifications,
        } = payload;

        const isPayloadEmpty =
          payloadMeta?.count === 0 ||
          (payloadData?.length === 0 &&
            (payloadNotifications ?? []).some(
              n => Boolean(n.uiMessage) && n.controls?.length
            ));

        if (isPayloadEmpty) {
          const { viewId, tabIndex, listIndex } = action.meta.arg || {};
          const view: View | undefined = action.meta.arg?.view;
          const tabLists = currentState.viewData[viewId]?.tabs[tabIndex]?.lists;

          const isNextListExisting =
            (view?.tabs?.[tabIndex]?.content?.length ?? 0) > listIndex + 1;

          const isNextListLoaded = Boolean(tabLists?.[listIndex + 1]);

          return isNextListExisting && !isNextListLoaded;
        }
      }
    }

    return false;
  },
  effect: (action, listenerApi) => {
    if (!isAnyOf(loadCardPage.fulfilled)(action)) return;

    const { viewId, tabIndex, listIndex } = action.meta.arg || {};
    const view: View | undefined = action.meta.arg?.view;
    const nextListIndex = listIndex + 1;

    const nextIsList = isList(view?.tabs?.[tabIndex]?.content?.[nextListIndex]);

    if (nextIsList) {
      void listenerApi.dispatch(
        loadCardPage({
          listIndex: nextListIndex,
          view,
          tabIndex,
          pageIndex: 0,
          viewId,
          userLoginCookie: action.meta.arg.userLoginCookie,
          user: action.meta.arg.user,
        })
      );
    }

    const highlightCard = view?.tabs?.[tabIndex]?.content?.[nextListIndex];

    if (isHighlightCard(highlightCard)) {
      listenerApi.dispatch(
        addHighlightCard({
          highlightCard,
          viewId,
          tabIndex,
          listIndex: nextListIndex,
        })
      );
    }
  },
};

export default emptyListLoadedListener;
